import { render, staticRenderFns } from "./LayoutPreview.vue?vue&type=template&id=48e8bff0&scoped=true"
import script from "./LayoutPreview.vue?vue&type=script&lang=js"
export * from "./LayoutPreview.vue?vue&type=script&lang=js"
import style0 from "./LayoutPreview.vue?vue&type=style&index=0&id=48e8bff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e8bff0",
  null
  
)

export default component.exports